import React from "react";
import "./DialogScreenMask.scoped.scss";
import { MdOutlineCloseFullscreen } from "react-icons/md";
import { IconContext } from "react-icons";

interface Props {
  readonly close: () => void;
  readonly visible: boolean;
  readonly children: React.ReactNode;
}

export default function DialogScreenMask(props: Props) {
  if (props.visible) {
    return (
      <div className="bg_full" onClick={() => props.close()}>
        <div
          className="content"
          onClick={
            (event) =>
              event.stopPropagation() /*画像をクリックしても閉じないように*/
          }
        >
          {props.children}
        </div>
        <IconContext.Provider value={{ color: "lightgray", size: "100%" }}>
          <div className="closer" onClick={() => props.close()}>
            <MdOutlineCloseFullscreen />
          </div>
        </IconContext.Provider>
      </div>
    );
  } else {
    return null;
  }
}
